import { render, staticRenderFns } from "./FormAnswer.vue?vue&type=template&id=10fdf3eb&scoped=true&"
import script from "./FormAnswer.vue?vue&type=script&lang=js&"
export * from "./FormAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FormAnswer.vue?vue&type=style&index=0&id=10fdf3eb&lang=scss&scoped=true&"
import style1 from "./FormAnswer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdf3eb",
  null
  
)

export default component.exports